import { render, staticRenderFns } from "./ScanBarcodeModule.vue?vue&type=template&id=422469b4"
import script from "./ScanBarcodeModule.vue?vue&type=script&lang=js"
export * from "./ScanBarcodeModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports